import React from 'react';
import ReactTypingEffect from 'react-typing-effect';
import { HiDownload, HiSparkles } from 'react-icons/hi';

const About = () => {
  return (
    <section
      id="about"
      className="min-h-screen flex items-center justify-center py-20 px-[6vw] md:px-[8vw] lg:px-[15vw] relative overflow-hidden"
    >
      <div className="max-w-7xl w-full grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        {/* Left Content */}
        <div className="lg:col-span-8 text-center lg:text-left space-y-6 z-10">
          
          {/* Status Badge */}
          <div className="inline-flex items-center space-x-2 bg-purple-950/40 border border-purple-500/30 px-4 py-2 rounded-full shadow-[0_0_15px_rgba(130,69,236,0.15)] backdrop-blur-md">
            <HiSparkles className="text-[#8245ec] animate-spin" style={{ animationDuration: '4s' }} />
            <span className="text-xs sm:text-sm font-medium text-purple-300 tracking-wide">
              Java & Full-Stack Developer | Ready for Impact
            </span>
          </div>

          {/* Heading Name */}
          <div className="space-y-2">
            <h1 className="text-4xl sm:text-6xl lg:text-7xl font-extrabold text-white tracking-tight leading-none">
              Hi, I'm <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-purple-200 to-[#8245ec]">Yash Soni</span>
            </h1>
            <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-400 mt-2">
              I am a <span className="text-[#8245ec]">
                <ReactTypingEffect
                  text={[
                    'Java Developer',
                    'Fullstack Developer',
                    'MERN Stack Specialist',
                    'Spring Boot Architect'
                  ]}
                  speed={80}
                  eraseSpeed={40}
                  typingDelay={400}
                  eraseDelay={2000}
                  cursorRenderer={(cursor) => <span className="text-[#8245ec]">{cursor}</span>}
                />
              </span>
            </div>
          </div>

          {/* Description */}
          <p className="text-base sm:text-lg text-gray-400 max-w-2xl mx-auto lg:mx-0 font-normal leading-relaxed">
            Java and MERN stack developer specializing in building scalable, high-performance web applications and robust enterprise back-end systems. Adept at bridging enterprise-grade architecture with seamless, user-centric digital solutions.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 pt-4">
            <a
              href="https://drive.google.com/file/d/1OV5MZ_JzGXK3xcYbaj4cbt2NeuQztefN/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto inline-flex items-center justify-center space-x-3 text-white px-8 py-4 rounded-xl font-bold text-base transition-all duration-300 transform hover:-translate-y-1 shadow-[0_0_25px_rgba(130,69,236,0.4)] hover:shadow-[0_0_35px_rgba(130,69,236,0.7)] bg-gradient-to-r from-[#8245ec] to-purple-600 border border-purple-400/30"
            >
              <span>Download Resume</span>
              <HiDownload size={20} />
            </a>

            <a
              href="#contact"
              className="w-full sm:w-auto inline-flex items-center justify-center text-gray-300 hover:text-white px-8 py-4 rounded-xl font-bold text-base transition-all duration-300 bg-white/[0.03] hover:bg-white/[0.08] border border-white/10 hover:border-[#8245ec]/50"
            >
              Let's Connect
            </a>
          </div>

        </div>

        {/* Right Side Visual Element */}
        <div className="lg:col-span-4 relative flex justify-center">
          <div className="w-full max-w-sm bg-gradient-to-b from-white/[0.08] to-white/[0.02] border border-white/10 p-6 rounded-3xl backdrop-blur-2xl shadow-[0_0_50px_rgba(130,69,236,0.15)] relative group hover:border-[#8245ec]/50 transition-all duration-500">
            <div className="absolute -top-3 -right-3 bg-[#8245ec] text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg animate-bounce">
              v2.6 Live
            </div>
            <div className="space-y-4 font-mono text-sm text-gray-300">
              <div className="flex items-center space-x-2 pb-3 border-b border-white/10">
                <div className="w-3 h-3 rounded-full bg-red-500/80"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-500/80"></div>
                <div className="w-3 h-3 rounded-full bg-green-500/80"></div>
                <span className="text-xs text-gray-500 pl-2">yash-profile.config.js</span>
              </div>
              <p className="text-purple-400">const developer = &#123;</p>
              <p className="pl-4 text-gray-300">name: <span className="text-green-300">'Yash Soni'</span>,</p>
              <p className="pl-4 text-gray-300">stack: <span className="text-green-300">'Java + MERN'</span>,</p>
              <p className="pl-4 text-gray-300">focus: <span className="text-green-300">['Spring Boot', 'React']</span>,</p>
              <p className="pl-4 text-gray-300">status: <span className="text-amber-300">'Open to Hire'</span></p>
              <p className="text-purple-400">&#125;;</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default About;